import negate from 'lodash/negate';
import isBrowser from './isBrowser';

export default negate(isBrowser);
